// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__dlL5j","shine-lines":"styles_shine-lines__dUuCz","show":"styles_show__2PB3W"};